// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "acquisitionspa." + chunkId + "." + "534ce30ef52af91f2e11" + ".chunk.js";
};